import React, {Component} from "react";
import {NavLink} from "react-router-dom";
import '../ClubLoginComponent/Login.css'

export default class CreateAccount extends Component{
render() {

return(
    <div className="login__box__right">
        <h2 className="login__box-haeding text-jost-sb-22">Don’t have an account?</h2>
        <p className="login__box-para text-ops-rg-16">Don’t delay create your account today by following this link
        </p>
        <NavLink to="/club-detail" target="_self" className="res-btn-primary">Create an
            account</NavLink>
    </div>

)
}}
